module.exports = __webpack_public_path__ + "static/media/accessible-icon-alt.b020588d.svg";